import { AbstractControl, ValidatorFn } from '@angular/forms';

export function dutchPersonNumberValidator(): ValidatorFn {
  return (control: AbstractControl): { [key: string]: any } | null => {
    if (!control.value) { return null; }
    const re = /\d{9}/;
    const valid = re.test(control.value);
    return valid ? null : { invalidDutchSSN: true };
  };
}
